import type { Content, Location } from '@plone/types';

export function getRelatedLocations(content?: Content): Location[] {
  if (!content) return [];
  const rel = (content as any).related_locations;
  return Array.isArray(rel) ? rel : [];
}

export function hasRelatedLocations(content?: Content): boolean {
  const rel = getRelatedLocations(content);
  return rel.length > 0;
}
